import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { dateWithFormat } from "../../tools";

export default function modelDataValueUpdateTsTimingDetails({ row }) {
    const fields = [
        { label: 'Start Date', oldKey: 'old_start_date', newKey: 'new_start_date', format: dateWithFormat },
        { label: 'End Date', oldKey: 'old_end_date', newKey: 'new_end_date', format: dateWithFormat },
        { label: 'Periodicity', oldKey: 'old_periodicity', newKey: 'new_periodicity', format: (v) => v },
    ];

    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <div className="mt-3 overflow-hidden rounded-lg border border-slate-200">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-200">
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500">Field</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500">Before</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-slate-500">After</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                        {fields.map(({ label, oldKey, newKey, format }) => {
                            const oldVal = row[oldKey];
                            const newVal = row[newKey];
                            const changed = oldVal !== newVal;

                            return (
                                <tr key={label} className={changed ? 'bg-amber-50/50' : ''}>
                                    <td className="px-3 py-2 text-slate-700">{label}</td>
                                    <td className="px-3 py-2">
                                        <span className={changed ? 'text-red-600 bg-red-50 px-1.5 py-0.5 rounded' : 'text-slate-600'}>
                                            {oldVal ? format(oldVal) : 'empty'}
                                        </span>
                                    </td>
                                    <td className="px-3 py-2">
                                        <span className={changed ? 'text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded' : 'text-slate-600'}>
                                            {newVal ? format(newVal) : 'empty'}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </ModelDataValueUpdateDetailsBase>
    );
}
